import React from "react";

const ProfessorsSection = ({ 
  handleFileChange, 
  handleFileUpload, 
  handleDownload, 
  handleSendEmail, 
  handleDownloadProjectCSV, // New prop for downloading project CSV
  file, 
  loading,
  downloadCSVLoading // New prop for CSV download loading state
}) => {
  return (
    <div className="professors-section">
      <h1>Professors Management</h1>
      <div style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr", // Changed to 4 columns
        gap: "20px",
        marginBottom: "20px"
      }}>
        <div style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "column"
        }}>
          <h2>Upload Professors</h2>
          <input
            type="file"
            accept=".xlsx, .xls, .csv"
            onChange={handleFileChange}
            style={{
              padding: "10px",
              marginBottom: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              width: "100%",
            }}
          />
          <button
            onClick={handleFileUpload}
            disabled={!file || loading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#3498db",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
              marginTop: "auto",
              opacity: (!file || loading) ? 0.6 : 1
            }}
          >
            {loading ? "Uploading..." : "Upload File"}
          </button>
        </div>

        <div style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "column"
        }}>
          <h2>Download Professors</h2>
          <button
            onClick={handleDownload}
            disabled={loading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#2ecc71",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
              marginTop: "auto",
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? "Preparing..." : "Download Professors"}
          </button>
        </div>

        <div style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "column"
        }}>
          <h2>Send Emails to Professors</h2>
          <button
            onClick={handleSendEmail}
            disabled={loading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#f39c12",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
              marginTop: "auto",
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? "Sending..." : "Send Emails"}
          </button>
        </div>

        {/* New Download Project CSV Card */}
        <div style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "column"
        }}>
          <h2>Download Project Details</h2>
          <p style={{
            fontSize: "14px",
            color: "#666",
            marginBottom: "15px",
            flexGrow: 1
          }}>
            Download CSV for all the project details
          </p>
          <button
            onClick={handleDownloadProjectCSV}
            disabled={downloadCSVLoading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#59a5b6ff", 
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
              marginTop: "auto",
              opacity: downloadCSVLoading ? 0.6 : 1
            }}
          >
            {downloadCSVLoading ? "Downloading..." : "Download Projects CSV"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfessorsSection;